"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTrue = exports.hasCookiePermission = exports.REQUIRED_COOKIE_NAME = exports.PERFORMANCE_COOKIE_NAME = exports.MARKETING_COOKIE_NAME = exports.LEADGENERATION_COOKIE_NAME = exports.FUNCTIONAL_COOKIE_NAME = exports.CookieProvider = exports.CookieContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _webVitals = require("web-vitals");
var _utils = require("../pwa-kit/utils/utils");
var _useConfig = require("../hooks/useConfig");
var _TagManager = _interopRequireDefault(require("../utils/TagManager"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } // @ts-ignore
// @ts-ignore
const REQUIRED_COOKIE_NAME = 'RequiredAllowed';
exports.REQUIRED_COOKIE_NAME = REQUIRED_COOKIE_NAME;
const FUNCTIONAL_COOKIE_NAME = 'FuncionalAllowed';
exports.FUNCTIONAL_COOKIE_NAME = FUNCTIONAL_COOKIE_NAME;
const PERFORMANCE_COOKIE_NAME = 'PerformanceAllowed';
exports.PERFORMANCE_COOKIE_NAME = PERFORMANCE_COOKIE_NAME;
const MARKETING_COOKIE_NAME = 'MarketingAllowed';
exports.MARKETING_COOKIE_NAME = MARKETING_COOKIE_NAME;
const LEADGENERATION_COOKIE_NAME = 'LeadGenerationProposed';
exports.LEADGENERATION_COOKIE_NAME = LEADGENERATION_COOKIE_NAME;
const CookieContext = /*#__PURE__*/(0, _react.createContext)({
  isConfirmed: false,
  isFunctionalAllowed: false,
  isPerformanceAllowed: false,
  isMarketingAllowed: false,
  isModalOpen: false,
  showDetails: false,
  isLeadGenerationProposed: false,
  setCookiesAllowed: () => {},
  setCookieModal: () => {},
  setLeadGenerationCookieProposed: () => {},
  eventTracking: () => {},
  getCookieFlags: () => {}
});
exports.CookieContext = CookieContext;
const hasCookiePermission = cookieName => {
  return _jsCookie.default.get(cookieName) === 'true';
};
exports.hasCookiePermission = hasCookiePermission;
const isTrue = val => {
  return typeof val === 'boolean' ? val === true : val === 'true';
};

// @ts-ignore
exports.isTrue = isTrue;
const sendEvents = (...events) => {
  // @ts-ignore
  const dataLayer = window.dataLayer || [];
  // @ts-ignore
  if (events[0] && events[0].ecommerce) {
    dataLayer.push({
      ecommerce: null
    });
  }
  dataLayer.push(...events);
  // @ts-ignore
  window.dataLayer = dataLayer;
};
const CookieProvider = ({
  children,
  gtmId
}) => {
  const {
    cookiePrefix,
    gtmDomain
  } = (0, _useConfig.useConfig)();
  const [isCookieModalOpen, setCookieModalOpen] = (0, _react.useState)(false);
  const [isDetailsOpen, setIsDetailsOpen] = (0, _react.useState)(false);
  const [isFunctionalAllowed, setIsFunctionalAllowed] = (0, _react.useState)(false);
  const [isPerformanceAllowed, setIsPerformanceAllowed] = (0, _react.useState)(false);
  const [isMarketingAllowed, setIsMarketingAllowed] = (0, _react.useState)(false);
  //TODO: its not clear if we still need this lead generation funcionality like old Jasmin
  const [isLeadGenerationProposed, setIsLeadGenerationProposed] = (0, _react.useState)(false);
  const [isConfirmed, setIsConfirmed] = (0, _react.useState)(true);
  const requiredCookieName = `${cookiePrefix}${REQUIRED_COOKIE_NAME}`;
  const functionalCookieName = `${cookiePrefix}${FUNCTIONAL_COOKIE_NAME}`;
  const performanceCookieName = `${cookiePrefix}${PERFORMANCE_COOKIE_NAME}`;
  const marketingCookieName = `${cookiePrefix}${MARKETING_COOKIE_NAME}`;
  const leadGenerationCookieName = `${cookiePrefix}${LEADGENERATION_COOKIE_NAME}`;
  const initializeTracker = () => {
    _TagManager.default.initialize({
      gtmId: gtmId,
      dataLayer: {
        // eslint-disable-next-line no-restricted-globals
        originalLocation: `${location.protocol}//${location.hostname}${location.pathname}${location.search}`
      },
      domain: gtmDomain
    });
  };
  const pushToDataLayer = data => {
    _TagManager.default.dataLayer({
      dataLayer: {
        event: 'coreWebVitals',
        webVitalsMeasurement: {
          name: data === null || data === void 0 ? void 0 : data.name,
          id: data === null || data === void 0 ? void 0 : data.id,
          value: data === null || data === void 0 ? void 0 : data.value,
          delta: data === null || data === void 0 ? void 0 : data.delta,
          valueRounded: Math.round(data === null || data === void 0 ? void 0 : data.value),
          deltaRounded: Math.round(data === null || data === void 0 ? void 0 : data.delta)
        }
      }
    });
  };
  const initializeWebVitals = () => {
    (0, _webVitals.onCLS)(pushToDataLayer);
    (0, _webVitals.onFID)(pushToDataLayer);
    (0, _webVitals.onLCP)(pushToDataLayer);
  };
  (0, _react.useEffect)(() => {
    setIsConfirmed(isTrue(_jsCookie.default.get(requiredCookieName) || 'false'));
    setIsFunctionalAllowed(isTrue(_jsCookie.default.get(functionalCookieName) || 'false'));
    setIsPerformanceAllowed(isTrue(_jsCookie.default.get(performanceCookieName) || 'false'));
    setIsMarketingAllowed(isTrue(_jsCookie.default.get(marketingCookieName) || 'false'));
    setIsLeadGenerationProposed(isTrue(_jsCookie.default.get(leadGenerationCookieName) || 'false'));
  }, []);
  (0, _react.useEffect)(() => {
    if (isMarketingAllowed) {
      initializeTracker();
    }
  }, [isMarketingAllowed]);
  (0, _react.useEffect)(() => {
    if (isPerformanceAllowed) {
      initializeWebVitals();
    }
  }, [isPerformanceAllowed]);
  const setConfirmed = (val = false) => {
    _jsCookie.default.set(requiredCookieName, val, {
      sameSite: 'strict',
      expires: 365
    });
    setIsConfirmed(val);
  };
  const setFunctionalAllowed = (val = false) => {
    _jsCookie.default.set(functionalCookieName, val, {
      sameSite: 'strict',
      expires: 365
    });
    setIsFunctionalAllowed(val);
  };
  const setPerformanceAllowed = (val = false) => {
    _jsCookie.default.set(performanceCookieName, val, {
      sameSite: 'strict',
      expires: 365
    });
    setIsPerformanceAllowed(val);
  };
  const setMarketingAllowed = (val = false) => {
    _jsCookie.default.set(marketingCookieName, val, {
      sameSite: 'strict',
      expires: 365
    });
    setIsMarketingAllowed(val);
  };
  const setLeadGenerationCookieProposed = (val = false) => {
    _jsCookie.default.set(leadGenerationCookieName, val, {
      sameSite: 'strict',
      expires: 365
    });
    setIsLeadGenerationProposed(val);
  };
  const setCookiesAllowed = values => {
    const {
      required,
      functional,
      performance,
      marketing
    } = values;
    sendEvents({
      event: isConfirmed ? 'consent_updated' : 'consent_given',
      consent_functional: functional,
      consent_lb: performance,
      consent_marketing: marketing
    });
    setConfirmed(required);
    setFunctionalAllowed(functional);
    setPerformanceAllowed(performance);
    setMarketingAllowed(marketing);
    setCookieModalOpen(false);
  };
  const handleCookieModal = (isOpen, showDetails) => {
    setCookieModalOpen(isOpen);
    setIsDetailsOpen(showDetails);
  };
  const setCookieModal = (isOpen, showDetails) => handleCookieModal(isOpen, showDetails);
  const eventTracking = (eventName, eventData) => {
    if (_utils.isServer || !isPerformanceAllowed) return;
    try {
      sendEvents(_objectSpread({
        event: eventName
      }, eventData));
    } catch (e) {
      //TODO: we need a logger
    }
  };
  let initialFunctionalCookieAllowed = false;
  let initialPerformanceCookieAllowed = false;
  let initialMarketingCookieAllowed = false;

  // If marketing cookie has not been set yet, pre-select it in the cookie
  // modal, otherwise take state value
  if (!_utils.isServer) {
    initialFunctionalCookieAllowed = _jsCookie.default.get(functionalCookieName) === undefined ? false : isFunctionalAllowed;
    initialPerformanceCookieAllowed = _jsCookie.default.get(performanceCookieName) === undefined ? false : isPerformanceAllowed;
    initialMarketingCookieAllowed = _jsCookie.default.get(marketingCookieName) === undefined ? false : isMarketingAllowed;
  }

  // Workaround for Einstein Recommendations on initial page load
  const getCookieFlags = () => {
    if (_utils.isServer) return {};
    return {
      isFunctionalAllowed: isTrue(_jsCookie.default.get(functionalCookieName) || 'false'),
      isPerformanceAllowed: isTrue(_jsCookie.default.get(performanceCookieName) || 'false'),
      isMarketingAllowed: isTrue(_jsCookie.default.get(marketingCookieName) || 'false')
    };
  };
  return /*#__PURE__*/_react.default.createElement(CookieContext.Provider, {
    value: {
      isConfirmed,
      isFunctionalAllowed,
      isPerformanceAllowed,
      isMarketingAllowed,
      isLeadGenerationProposed,
      setCookiesAllowed,
      setCookieModal,
      setLeadGenerationCookieProposed,
      isModalOpen: isCookieModalOpen,
      showDetails: isDetailsOpen,
      eventTracking: eventTracking,
      getCookieFlags: getCookieFlags
    }
  }, children);
};
exports.CookieProvider = CookieProvider;